import { useAppSelector } from "@hooks/redux";
import { useIsChinaMember } from "@store/globalSlice";

// 归属国家中国且地区英国或者美国才显示
export const useFullServiceDisplay = () => {
  const { isChinaMember } = useIsChinaMember();
  const { region } = useAppSelector((state) => state.globalReducer);
  let isShowFullService = false;
  if (isChinaMember && (region === "US" || region === "GB")) {
    isShowFullService = true;
  }
  return { isShowFullService };
};
